module.exports = __webpack_public_path__ + "static/img/banner3.d0bd3bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/image/banner3.png
// module id = PVTU
// module chunks = 1